import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISH_NAMES_QUERY } from '../graphql/queries'
import { FETCH_DISH_NAMES } from '../redux/action-types'

const useDishNamesQuery = filters => {
  const dispatch = useDispatch()

  const {
    isNamesLoading: isLoading,
    namesError: error,
    names: data,
  } = useSelector(store => store.dishes.dishes)

  const refetch = useCallback(
    filters =>
      apolloService.query({
        query: DISH_NAMES_QUERY,
        variables: {
          filters,
        },
        dispatch,
        action: FETCH_DISH_NAMES,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(filters)
  }, [filters, refetch])

  return { isLoading, error, data }
}

export default useDishNamesQuery
